export default {
  setInvoiceValues(state, invoiceValues = {}) {
    state.invoiceValues = invoiceValues;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/store/mutations.js